/* ==========================================================================
   AMJAD — theme.js
   Interactions UI portées du prototype + intégration Shopify Ajax Cart API.
   ========================================================================== */
(function(){
  "use strict";

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('[data-site-header]');
  if(header){
    var onScroll = function(){ header.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  var burger = document.querySelector('[data-burger]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var closeMenu = document.querySelector('[data-close-menu]');
  if(burger && mobileMenu){
    burger.addEventListener('click', function(){ mobileMenu.classList.add('open'); });
  }
  if(closeMenu && mobileMenu){
    closeMenu.addEventListener('click', function(){ mobileMenu.classList.remove('open'); });
  }
  if(mobileMenu){
    mobileMenu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ mobileMenu.classList.remove('open'); });
    });
  }

  /* ---------- Search overlay ---------- */
  var searchBtn = document.querySelector('[data-search-open]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');
  if(searchBtn && searchOverlay){
    searchBtn.addEventListener('click', function(e){
      e.preventDefault();
      searchOverlay.classList.add('open');
      if(searchInput) searchInput.focus();
    });
  }
  if(searchClose && searchOverlay){
    searchClose.addEventListener('click', function(){ searchOverlay.classList.remove('open'); });
  }
  // Auto-open search overlay if ?view=recherche is present (parity with prototype routing)
  if(searchOverlay){
    var params = new URLSearchParams(window.location.search);
    if(params.get('view') === 'recherche'){
      searchOverlay.classList.add('open');
    }
  }

  /* ---------- Accordion (FAQ, product page) ---------- */
  document.querySelectorAll('[data-acc-head]').forEach(function(head){
    head.addEventListener('click', function(){
      head.closest('.acc-item').classList.toggle('open');
    });
  });

  /* ---------- Wishlist (localStorage — per navigateur, non partagé) ---------- */
  var WISH_KEY = 'amjad_wishlist';
  function getWishlist(){
    try{ return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); }catch(e){ return []; }
  }
  function saveWishlist(list){
    try{ localStorage.setItem(WISH_KEY, JSON.stringify(list)); }catch(e){}
  }
  function updateWishBadge(){
    var badge = document.querySelector('[data-wish-count]');
    if(badge) badge.textContent = getWishlist().length;
  }
  document.querySelectorAll('[data-wish-toggle]').forEach(function(btn){
    var id = btn.getAttribute('data-wish-toggle');
    var list = getWishlist();
    if(list.indexOf(id) > -1) btn.classList.add('active');
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var l = getWishlist();
      var idx = l.indexOf(id);
      if(idx > -1){ l.splice(idx,1); btn.classList.remove('active'); }
      else{ l.push(id); btn.classList.add('active'); }
      saveWishlist(l);
      updateWishBadge();
    });
  });
  updateWishBadge();

  /* ---------- Cart badge (compte réel Shopify) ---------- */
  function refreshCartCount(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
        });
      })
      .catch(function(){});
  }
  refreshCartCount();

  /* ---------- Ajout au panier (Ajax) ---------- */
  function addToCart(variantId, quantity, onDone){
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ items:[{ id: variantId, quantity: quantity }] })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      refreshCartCount();
      if(onDone) onDone(null, data);
    })
    .catch(function(err){ if(onDone) onDone(err); });
  }
  window.AMJAD = window.AMJAD || {};
  window.AMJAD.addToCart = addToCart;
  window.AMJAD.refreshCartCount = refreshCartCount;

  // Boutons génériques "ajouter au panier rapide" (cartes produit, sans sélection de variante)
  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if(!variantId) return;
      var original = btn.innerHTML;
      addToCart(variantId, 1, function(err){
        if(!err){
          btn.innerHTML = 'Ajouté ✓';
          setTimeout(function(){ btn.innerHTML = original; }, 1300);
        }
      });
    });
  });

  /* ---------- Recommandations produit (chargées en asynchrone) ---------- */
  var recoPlaceholder = document.getElementById('product-recommendations-placeholder');
  if(recoPlaceholder){
    var pid = recoPlaceholder.getAttribute('data-product-id');
    fetch('/recommendations/products?product_id=' + pid + '&limit=6&intent=related&section_id=product-recommendations')
      .then(function(r){ return r.text(); })
      .then(function(html){
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var section = temp.querySelector('#product-recommendations');
        if(section && section.children.length){ recoPlaceholder.replaceWith(section); }
      })
      .catch(function(){});
  }

  /* ---------- Page produit : sélection couleur / taille / quantité ---------- */
  var pdpForm = document.querySelector('[data-product-form]');
  if(pdpForm){
    var productDataEl = document.querySelector('[data-product-json]');
    var product = productDataEl ? JSON.parse(productDataEl.textContent) : null;
    var selected = {}; // { "Couleur": "Noir", "Taille": "M" }
    var qtyInput = pdpForm.querySelector('[data-qty-input]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var variantIdInput = pdpForm.querySelector('[data-variant-id-input]');
    var mbPrice = document.querySelector('[data-mb-price]');
    var mbName = document.querySelector('[data-mb-name]');
    var stockNote = document.querySelector('[data-stock-note]');

    function findVariant(){
      if(!product) return null;
      return product.variants.find(function(v){
        return product.options.every(function(optName, i){
          var key = 'option' + (i+1);
          return !selected[optName] || v[key] === selected[optName];
        });
      });
    }

    function formatMoney(cents){
      return (cents/100).toLocaleString('fr-FR', {minimumFractionDigits: (cents % 100 === 0) ? 0 : 2, maximumFractionDigits:2}) + ' €';
    }

    function updateUI(){
      var variant = findVariant();
      if(!variant) return;
      if(variantIdInput) variantIdInput.value = variant.id;
      if(priceEl) priceEl.textContent = formatMoney(variant.price);
      if(mbPrice) mbPrice.textContent = formatMoney(variant.price);
      if(mbName) mbName.textContent = product.title;

      var addBtn = pdpForm.querySelector('[data-add-submit]');
      var buyBtn = document.querySelector('[data-buy-now]');
      var available = variant.available;
      [addBtn, buyBtn].forEach(function(b){
        if(!b) return;
        b.disabled = !available;
        b.textContent = available ? b.getAttribute('data-label-available') : 'Rupture de stock';
      });
      if(stockNote){
        var lowStock = variant.inventory_quantity !== undefined && variant.inventory_quantity > 0 && variant.inventory_quantity <= 3;
        stockNote.classList.toggle('show', !!lowStock);
      }

      // Update swatch/size disabled state based on availability of resulting combos
      pdpForm.querySelectorAll('[data-option-value]').forEach(function(el){
        var optName = el.getAttribute('data-option-name');
        var optValue = el.getAttribute('data-option-value');
        var test = Object.assign({}, selected);
        test[optName] = optValue;
        var possible = product.variants.some(function(v){
          return product.options.every(function(o, i){
            var key = 'option'+(i+1);
            return !test[o] || v[key] === test[o];
          }) && v.available;
        });
        el.toggleAttribute('disabled', !possible);
      });
    }

    pdpForm.querySelectorAll('[data-option-value]').forEach(function(el){
      var optName = el.getAttribute('data-option-name');
      var optValue = el.getAttribute('data-option-value');
      if(el.classList.contains('selected')) selected[optName] = optValue;
      el.addEventListener('click', function(){
        if(el.hasAttribute('disabled')) return;
        selected[optName] = optValue;
        pdpForm.querySelectorAll('[data-option-name="'+optName+'"]').forEach(function(s){ s.classList.remove('selected'); });
        el.classList.add('selected');
        var nameLabel = pdpForm.querySelector('[data-option-name-label="'+optName+'"]');
        if(nameLabel) nameLabel.textContent = optValue;
        updateUI();
      });
    });

    if(qtyInput){
      pdpForm.querySelectorAll('[data-qty-minus]').forEach(function(b){
        b.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10)||1) - 1); });
      });
      pdpForm.querySelectorAll('[data-qty-plus]').forEach(function(b){
        b.addEventListener('click', function(){ qtyInput.value = (parseInt(qtyInput.value,10)||1) + 1; });
      });
    }

    updateUI();

    pdpForm.addEventListener('submit', function(e){
      e.preventDefault();
      var variant = findVariant();
      if(!variant || !variant.available) return;
      var qty = qtyInput ? (parseInt(qtyInput.value,10)||1) : 1;
      var btn = pdpForm.querySelector('[data-add-submit]');
      var original = btn ? btn.textContent : '';
      if(btn) btn.textContent = 'Ajout en cours…';
      addToCart(variant.id, qty, function(err){
        if(btn) btn.textContent = err ? original : 'Ajouté au panier ✓';
        setTimeout(function(){ if(btn) btn.textContent = original; }, 1400);
      });
    });

    var buyNowBtn = document.querySelector('[data-buy-now]');
    if(buyNowBtn){
      buyNowBtn.addEventListener('click', function(){
        var variant = findVariant();
        if(!variant || !variant.available) return;
        var qty = qtyInput ? (parseInt(qtyInput.value,10)||1) : 1;
        addToCart(variant.id, qty, function(err){
          if(!err) window.location.href = '/checkout';
        });
      });
    }

    /* Galerie : swipe + miniatures */
    var galleryMain = document.querySelector('[data-gallery-main]');
    var dots = document.querySelectorAll('[data-gallery-dot]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if(galleryMain){
      galleryMain.addEventListener('scroll', function(){
        var idx = Math.round(galleryMain.scrollLeft / galleryMain.clientWidth);
        dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
        thumbs.forEach(function(t,i){ t.classList.toggle('active', i===idx); });
      });
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var i = parseInt(t.getAttribute('data-gallery-thumb'),10);
          galleryMain.scrollTo({left: galleryMain.clientWidth * i, behavior:'smooth'});
        });
      });
    }

    /* Barre d'achat sticky mobile : visible quand le bouton principal sort de l'écran */
    var addSubmitBtn = pdpForm.querySelector('[data-add-submit]');
    var mobileBar = document.querySelector('[data-mobile-buybar]');
    if(addSubmitBtn && mobileBar && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ mobileBar.classList.toggle('show', !en.isIntersecting); });
      }, {threshold:0});
      io.observe(addSubmitBtn);
    }

    /* Guide des tailles (modal) */
    var sizeGuideBtn = document.querySelector('[data-size-guide-open]');
    var sizeModal = document.querySelector('[data-size-modal]');
    var sizeModalBackdrop = document.querySelector('[data-size-modal-backdrop]');
    if(sizeGuideBtn && sizeModal){
      sizeGuideBtn.addEventListener('click', function(){ sizeModal.classList.add('open'); if(sizeModalBackdrop) sizeModalBackdrop.classList.add('open'); });
      document.querySelectorAll('[data-size-modal-close]').forEach(function(b){
        b.addEventListener('click', function(){ sizeModal.classList.remove('open'); if(sizeModalBackdrop) sizeModalBackdrop.classList.remove('open'); });
      });
    }
  }

  /* ---------- Page panier : quantité / suppression (Ajax) ---------- */
  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('[data-cart-qty-input="'+line+'"]');
      if(!input) return;
      var delta = btn.hasAttribute('data-cart-qty-plus') ? 1 : -1;
      var next = Math.max(0, (parseInt(input.value,10)||1) + delta);
      updateCartLine(line, next);
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function(btn){
    btn.addEventListener('click', function(){
      updateCartLine(btn.getAttribute('data-cart-remove'), 0);
    });
  });
  function updateCartLine(line, quantity){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(){ window.location.reload(); })
    .catch(function(){});
  }

  /* Note : le formulaire newsletter est un formulaire natif Shopify (postback serveur).
     La confirmation d'inscription est gérée directement en Liquid dans sections/newsletter.liquid,
     aucun script n'est nécessaire ici. */

  /* ---------- Recherche prédictive légère (fallback simple) ---------- */
  var searchForm = document.querySelector('[data-search-form]');
  if(searchForm){
    var resultsBox = document.querySelector('[data-search-results]');
    var input2 = searchForm.querySelector('input[type="search"]');
    var hint = document.querySelector('[data-search-hint]');
    var timer;
    if(input2){
      input2.addEventListener('input', function(){
        clearTimeout(timer);
        var q = input2.value.trim();
        if(q.length < 2){ if(resultsBox) resultsBox.innerHTML=''; if(hint) hint.style.display='block'; return; }
        if(hint) hint.style.display='none';
        timer = setTimeout(function(){
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
            .then(function(r){ return r.json(); })
            .then(function(data){
              if(!resultsBox) return;
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if(!products.length){
                resultsBox.innerHTML = '<p style="grid-column:1/-1; font-family:Cormorant,serif; font-style:italic; color:var(--espresso);">Aucun résultat pour « '+q+' »</p>';
                return;
              }
              resultsBox.innerHTML = products.map(function(p){
                var img = p.featured_image ? p.featured_image.url : '';
                return '<a class="product-card" href="'+p.url+'">'+
                  '<div class="product-media">'+(img ? '<img class="img-a" src="'+img+'" alt="'+p.title+'">' : '<div class="placeholder-gradient"></div>')+'</div>'+
                  '<div class="product-info"><div class="product-info-row"><span class="product-name">'+p.title+'</span><span class="product-price">'+p.price+'</span></div></div>'+
                '</a>';
              }).join('');
            })
            .catch(function(){});
        }, 250);
      });
    }
  }

})();
